var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayer2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 94,
    viewBox: "0 0 50 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "field-marks",
    strokeWidth: 0.25,
    stroke: "#909da8",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 5.25,
    r: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 4,
    x2: 28,
    y2: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    width: 12,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 19 19 A 6 6 0 0 0 31 19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.34 0 L 3.34 9.86 A 22.15 22.15 0 0 0 46.66 9.86 L 46.66 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 47,
    r: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "players",
    fontFamily: "Arial",
    fontSize: 6,
    textAnchor: "middle",
    dominantBaseline: "central"
  }, /*#__PURE__*/React.createElement("text", {
    x: 5,
    y: 30
  }, "1"), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 30
  }, "2"), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 30,
    r: 3,
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 25,
    y: 30
  }, "3"), /*#__PURE__*/React.createElement("text", {
    x: 35,
    y: 30
  }, "4"), /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 30
  }, "5")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayer2);
export default __webpack_public_path__ + "static/media/Player 2.769f3a72d857754c996013c3efffce78.svg";
export { ForwardRef as ReactComponent };